// Check if admin is logged in
export const isAdminLoggedIn = () => {
  const token = localStorage.getItem('adminToken');
  return !!token;
};

// Get admin token
export const getAdminToken = () => {
  return localStorage.getItem('adminToken');
};

// Logout admin
export const logoutAdmin = () => {
  localStorage.removeItem('adminToken');
};

// Check if user is logged in
export const isUserLoggedIn = () => {
  const token = localStorage.getItem('userToken');
  return !!token;
};

// Get user token
export const getUserToken = () => {
  return localStorage.getItem('userToken');
};

// Get user info
export const getUserInfo = () => {
  const userStr = localStorage.getItem('userInfo');
  return userStr ? JSON.parse(userStr) : null;
};

// Impersonation functions
export const startImpersonation = (adminToken, userToken, userInfo) => {
  // Store admin token separately for later restoration
  localStorage.setItem('adminTokenBackup', adminToken);
  // Set user token and info
  localStorage.setItem('userToken', userToken);
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
  localStorage.setItem('isImpersonating', 'true');
};

export const stopImpersonation = () => {
  // Restore admin token
  const adminToken = localStorage.getItem('adminTokenBackup');
  if (adminToken) {
    localStorage.setItem('adminToken', adminToken);
  }
  // Clear impersonation data
  localStorage.removeItem('userToken');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('adminTokenBackup');
  localStorage.removeItem('isImpersonating');
};

export const isImpersonating = () => {
  return localStorage.getItem('isImpersonating') === 'true';
};

// Logout user
export const logoutUser = () => {
  // If impersonating, restore admin session instead of full logout
  if (isImpersonating()) {
    stopImpersonation();
    return;
  }
  localStorage.removeItem('userToken');
  localStorage.removeItem('userInfo');
};

